import {makeStyles} from '@material-ui/core';
import HelperUtils from '@shared/utils/HelperUtils';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {DEFAULT_BLACK_COLOR, DEFAULT_GREY_COLOR} from 'src/style/variable';

const Styles = makeStyles(() => ({
  wrapper: {
    marginTop: '1rem',
    marginBottom: '1rem'
  },
  mainView: {
    color: DEFAULT_BLACK_COLOR,
    display: 'flex',
    alignItems: 'center'
  },
  textWrapper: {
    flex: 1,
    fontSize: '0.9rem'
  },
  typeColor: {
    color: '#8f8f90'
  },
  displayFlex: {
    display: 'flex'
  },
  copayAuditInfo: {
    color: DEFAULT_GREY_COLOR,
    fontSize: '0.8rem'
  }
}));

interface DueBalanceCardProps {
  type: string;
  description?: string;
  balance: number;
  location: string;
  addedBy?: string;
  addedAt?: string;
}

const DueBalancesCard = (props: DueBalanceCardProps): React.ReactElement => {
  const classes = Styles();

  const {description, balance, location, addedBy, addedAt} = props;
  const {t} = useTranslation();

  return (
    <div className={classes.wrapper}>
      <div className={classes.mainView}>
        <div className={classes.textWrapper}>
          {description && <div>{description}</div>}
          {/* <div className={classes.typeColor}>{type}</div> */}
          <div
            className={classes.displayFlex}
            data-test-id="pcl-guarantor-practiceLocation">
            {t('DUE_INVOICES.LOCATION')}: {location}
          </div>
          {addedBy && (
            <div
              className={[classes.displayFlex, classes.copayAuditInfo].join(
                ' '
              )}>
              {t('COMMON.ADDED_BY', {name: addedBy})}
            </div>
          )}
          {addedAt && (
            <div
              className={[classes.displayFlex, classes.copayAuditInfo].join(
                ' '
              )}>
              {t('COMMON.AT', {date: addedAt})}
            </div>
          )}
        </div>
        <div data-test-id="pcl-guarantor-locationAmount">
          {HelperUtils.formatCurrencyAmount(balance, true)}
        </div>
      </div>
    </div>
  );
};

export default DueBalancesCard;
